import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {Component, ElementRef, EventEmitter, Output, Renderer2, ViewChild, inject,ChangeDetectorRef, QueryList, ViewChildren} from '@angular/core';
import {MatAutocompleteSelectedEvent, MatAutocompleteModule, MatAutocompleteTrigger} from '@angular/material/autocomplete';
import {MatChipInputEvent, MatChipsModule} from '@angular/material/chips';
import {Observable, of} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {MatIconModule} from '@angular/material/icon';
import {NgFor, AsyncPipe} from '@angular/common';
import {MatFormFieldModule} from '@angular/material/form-field';
import {LiveAnnouncer} from '@angular/cdk/a11y';
import { FlightService } from 'src/app/services/flight.service';
import { Router,ActivatedRoute } from '@angular/router';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators,FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms'
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import { Subscription } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { UserService } from 'src/app/services/user.service';
import { UserInfo, UserInfoService } from 'src/app/services/user-info.service';
import {AirManagementService}  from 'src/app/services/air-management.service'
import * as mammoth from 'mammoth';
import {NotificationSettingsService} from 'src/app/services/notification-settings.service'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import {AirConfigService}  from 'src/app/services/air-config.service'

@Component({
  selector: 'app-flight',
  templateUrl: './flight.component.html',
  styleUrls: ['./flight.component.css']
})
export class FlightComponent {
  @Output() myOutput:EventEmitter<string>= new EventEmitter();  
  outputMessage:string="close";
generatePnr:boolean=false
  departure:any='Delhi'
  arrivel:any='Mumbai'
  departureTime:any
  arrivelTime:any
  directFlight:boolean=false
  prefAirline:any=''
  dealCode:any=''
  separatorKeysCodes: number[] = [ENTER, COMMA];
  separatorKeysCodesTo: number[] = [ENTER, COMMA];
   minData:any=new Date()
  fruitCtrl = new FormControl('DEL  Delhi,India - Indira Gandhi International Airport');
  filteredFruits: Observable<string[]>;
  fruits: any="DEL  Delhi,India - Indira Gandhi International Airport"
  // allFruits:any = [];
  allFruits:any=["BOM  Mumbai,India - Chhatrapati Shivaji International Airport","GOI  Goa,India - Dabolim Airport","PNQ  Pune,India - Pune Airport","DEL  Delhi,India - Indira Gandhi International Airport","BLR  Bangalore,India - Kempegowda International Airport","CCU  Kolkata,India - Netaji Subhash Chandra Bose International Airport","HYD  Hyderabad,India - Rajiv Gandhi International Airport","MAA  Madras,India - Chennai International Airport","RAJ  Rajkot,India - Rajkot Airport"]
  whereTo:any=["BOM  Mumbai,India - Chhatrapati Shivaji International Airport","GOI  Goa,India - Dabolim Airport","PNQ  Pune,India - Pune Airport","DEL  Delhi,India - Indira Gandhi International Airport","BLR  Bangalore,India - Kempegowda International Airport","CCU  Kolkata,India - Netaji Subhash Chandra Bose International Airport","HYD  Hyderabad,India - Rajiv Gandhi International Airport","MAA  Madras,India - Chennai International Airport","RAJ  Rajkot,India - Rajkot Airport"]

  
  
  // whereTo:any=[];
  ToCtrl = new FormControl('BOM  Mumbai,India - Chhatrapati Shivaji International Airport');
  filteredTo: Observable<string[]>;
  wherecity: any="BOM  Mumbai,India - Chhatrapati Shivaji International Airport"
  @ViewChild('fruitInput') fruitInput!: ElementRef<HTMLInputElement>;
  @ViewChild('airportToInput') ToInput!: ElementRef<HTMLInputElement>;
  @ViewChild('pickers') datePicker!: ElementRef<HTMLInputElement>;

  announcer = inject(LiveAnnouncer);
   travelType:any='AD'
  searchFg!:FormGroup

  showOneWay:boolean=false
  showReturn:boolean=false
  showMulti:boolean=false
  currentNumber: number = 1;
  ccurrentNumber: number = 0;
  icurrentNumber: number = 0;
  selectedItem: string = 'Economy';
  selectedPerson:string ='Adult'
  adult:any;
  child:any;
  Infants:any;
  searchData:any={
    any:"any"
  }
  userName:any
tokenData:any={
  userType:'',
  username:'',
  userUuid:'',
  name:'',
  PersonalBooking:false
}
loginUserType:any
constructor(private sanitizer: DomSanitizer,private NotificationSettingsService:NotificationSettingsService,private AirManagementService:AirManagementService,private renderer: Renderer2,private data:DataService,private FlightService:FlightService,private router:ActivatedRoute ,private route:Router,private fb : FormBuilder, private cdr: ChangeDetectorRef,   private toastMsgService : ToastmsgService,private userService : UserService,
  private userInfoService : UserInfoService,private AirConfigService:AirConfigService){
    
    this.loginUserType=sessionStorage.getItem('loginUserType')
    this.loginUserType=this.loginUserType.toUpperCase()
  this.tokenData.userType=userInfoService.getUserType();
  this.tokenData.userType=this.tokenData.userType.toUpperCase();
  this.tokenData.username=userInfoService.getUsername();
  this.tokenData.userUuid=this.userInfoService.getUserUuid()
  this.tokenData.PersonalBooking=this.userInfoService.getPersonalBooking()||false
  
                // console.log(parentId)
                 
                      if(this.tokenData.userType==='STAFF'){

                      this.generalConfig(0)
                    }else{
                        this.generalConfig(this.tokenData.userUuid)
                      }

                          

      this.tokenData.name=this.userInfoService.getUserDisplayname();
      
    
  
  if(this.tokenData.userType==='CORPORATE'||this.tokenData.userType==='AGENT'){
    this.userName={
      name:this.tokenData.name,
      userUid:this.tokenData.userUuid,
      username:this.tokenData.username

    }
  }
  this.getUsersList()
  
  this.data.portMessage.subscribe((message:any) => this.searchData = message)
  this.dealCodeList();

  this.carrierCodelist()
  if(this.searchData!="default message"){
    this.bookingType=this.searchData.userBookingContext
  }
  this.prefAirline=this.searchData.prefAirline||''
  this.directFlight=this.searchData.directFlight||false
  this.dealCode=this.searchData.dealCode||''
  this.showOneWay=true
  this.showReturn=true
  // console.log(this.searchData.travelType)
  this.travelType=this.searchData.travelType

  if(this.searchData?.journeyType==='return'){
    // if(this.travelType==='AD'){
    //   this.domInt.to='India'
    //   this.domInt.from='India'
      
    // }else{
    //   this.domInt.to=this.searchData?.countryTo
    //   this.domInt.from=this.searchData?.countryFrom
    // }
    this.domInt.to=this.searchData?.countryTo
      this.domInt.from=this.searchData?.countryFrom
    this.onRChangeDate()
  
  
      this.searchFg=this.fb.group({
        "fromAirport" :  [this.searchFg.value.fromAirport,[Validators.required]],
        "toAirport" : [this.searchFg.value.toAirport,[Validators.required]],
        "requestedDate":[ new Date(this.searchData?.airSearchRequestBaseDetails[0]?.requestedDate)],
        "requestedClass":[ this.searchData.airSearchRequestBaseDetails[0]?.requestedClass],
        "paxCount":[this.searchData?.paxCount],
        "adultCount":[this.searchData?.adultCount],
        "childCount":[this.searchData?.childCount],
        "infantCount":[this.searchData?.infantCount],
        "returnDate":[new Date(this.searchData?.airSearchRequestBaseDetails[1]?.requestedDate)],
        "menu":["return"]
      });
      this.ccurrentNumber=this.searchFg.value.childCount
    this.currentNumber=this.searchFg.value.adultCount
    this.icurrentNumber=this.searchFg.value.infantCount
    this.totalPassengers=this.searchFg.value.paxCount
      if(this.searchFg?.value?.returnDate){
        this.arrivelTime=this.dateFormate(this.searchFg?.value?.returnDate)?.split(' ')
      }
      if(this.searchFg?.value?.requestedDate){
        this.departureTime=this.dateFormate(this.searchFg?.value?.requestedDate)?.split(' ')
      }
     
      if( this.searchFg.value.requestedClass==="Y"){
      
        this.selectedItem='Economy'
      }
      if( this.searchFg.value.requestedClass==="F"
      ){
        this.selectedItem='First'    
    
      }
      if( this.searchFg.value.requestedClass==="C"){
        this.selectedItem='Business' 
       
    
      }
      if(this.searchFg.value.requestedClass==="W"){
        
        this.selectedItem='Premium Economy'
      }

  }else if(this.searchData?.journeyType==='oneWay'){
    // if(this.travelType==='AD'){
    //   this.domInt.to='India'
    //   this.domInt.from='India'
    // }else{
    
      this.domInt.to=this.searchData?.countryTo
      this.domInt.from=this.searchData?.countryFrom
    
    this.dataFields()
   
    // console.log(this.searchData.airSearchRequestBaseDetails[0]?.requestedDate)
    this.searchFg=this.fb.group({
      "fromAirport" :  [this.searchFg.value.fromAirport,[Validators.required]],
      "toAirport" : [this.searchFg.value.toAirport,[Validators.required]],
      "requestedDate":[ new Date(this.searchData.airSearchRequestBaseDetails[0]?.requestedDate)],
      "requestedClass":[ this.searchData.airSearchRequestBaseDetails[0].requestedClass],
      "paxCount":[this.searchData?.paxCount],
        "adultCount":[this.searchData?.adultCount],
        "childCount":[this.searchData?.childCount],
        "infantCount":[this.searchData?.infantCount],
      "returnDate":[''],
      "menu":["oneWay"]
    });
    this.ccurrentNumber=this.searchFg.value.childCount
    this.currentNumber=this.searchFg.value.adultCount
    this.icurrentNumber=this.searchFg.value.infantCount
    this.totalPassengers=this.searchFg.value.paxCount
    if(this.searchFg?.value?.requestedDate){
      this.departureTime=this.dateFormate(this.searchFg?.value?.requestedDate)?.split(' ')
    }

    if( this.searchFg.value.requestedClass==="Y"){
      
      this.selectedItem==='Economy'
    }
    if( this.searchFg.value.requestedClass==="F"
    ){
      this.selectedItem='First'    
  
    }
    if( this.searchFg.value.requestedClass==="C"){
      this.selectedItem='Business' 
     
  
    }
    if(this.searchFg.value.requestedClass==="W"){
      
      this.selectedItem='Premium Economy'
    }
    // console.log('secondlast')

  }else if(this.searchData?.journeyType==='multiCity'){
    this.showOneWay=false
    this.showReturn=false
    this.showMulti=true
    this.dataFields()
   
    // console.log(this.searchData.airSearchRequestBaseDetails[0]?.requestedDate)
    this.searchFg=this.fb.group({
      "fromAirport" :  [this.searchFg.value.fromAirport,[Validators.required]],
      "toAirport" : [this.searchFg.value.toAirport,[Validators.required]],
      "requestedDate":[ this.searchData.airSearchRequestBaseDetails[0]?.requestedDate],
      "requestedClass":[ this.searchData.airSearchRequestBaseDetails[0].requestedClass],
      "paxCount":[this.searchData?.paxCount],
        "adultCount":[this.searchData?.adultCount],
        "childCount":[this.searchData?.childCount],
        "infantCount":[this.searchData?.infantCount],
      "returnDate":[''],
      "menu":["multiCity"]
    });
    this.ccurrentNumber=this.searchFg.value.childCount
    this.currentNumber=this.searchFg.value.adultCount
    this.icurrentNumber=this.searchFg.value.infantCount
    this.totalPassengers=this.searchFg.value.paxCount
    if(this.searchFg?.value?.requestedDate){
      this.departureTime=this.dateFormate(this.searchFg?.value?.requestedDate)?.split(' ')
    }

    if( this.searchFg.value.requestedClass==="Y"){
      
      this.selectedItem==='Economy'
    }
    if( this.searchFg.value.requestedClass==="F"
    ){
      this.selectedItem='First'    
  
    }
    if( this.searchFg.value.requestedClass==="C"){
      this.selectedItem='Business' 
     
  
    }
    if(this.searchFg.value.requestedClass==="W"){
      
      this.selectedItem='Premium Economy'
    }
  }

 else{
  
 
  this.dataFields()


 
}


this.getFlightList()

 // this.searchFg.value.requestedDate=""
  this.adult=this.currentNumber+` `+"Adult"
  this.child=this.ccurrentNumber+` `+"Child"
  this.Infants=this.icurrentNumber+` `+"Infants"

  

  this.array.forEach((item:any)=>{
    
    item.filteredFrom=item.fromAirport.valueChanges.pipe(
      debounceTime(300), // Adjust the debounce time as needed
      distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)),
      startWith(null),
      map((airport: any | null) => (airport ? this._filter(airport) : item.whereFrom.slice())),
    );

    item.filteredTo = item.toAirport.valueChanges.pipe(
      debounceTime(300), // Adjust the debounce time as needed
      distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)),
      startWith(null),
      map((airports: any | null) => (airports ? this._filterTo(airports) : item.whereTo.slice())),
    );

  })
  this.filteredFruits = this.fruitCtrl.valueChanges.pipe(
    debounceTime(300), // Adjust the debounce time as needed
    distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)),
    startWith(null),
    map((airport: any | null) => (airport ? this._filter(airport) : this.allFruits.slice())),
  );
  this.filteredTo = this.ToCtrl.valueChanges.pipe(
    debounceTime(300), // Adjust the debounce time as needed
    distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)),
    startWith(null),
    map((airports: any | null) => (airports ? this._filterTo(airports) : this.whereTo.slice())),
  );
  
  this.notificationlist()
  if(this.isActive('/app/create-manual-cart')){
    this.minData=''
  }
}

setToInputStaticValue() {
  console.log("no no no")
  // Example: Set static value to the input element
    this.ToInput.nativeElement.value="BOM  Mumbai,India - Chhatrapati Shivaji International Airport"
  

  this.fruitInput.nativeElement.value="DEL  Delhi,India - Indira Gandhi International Airport"
  
}
DisplayName:any
ngOnInit(): void {
  let DisplayName:any
this.router.queryParams.subscribe(params => {
  let data:any
  data=this.objectToArray(params)
 
  for(let i=0 ;i <data.length; i++){
  
    DisplayName +=data[i];
  }

    });
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map((value:any) => this._filters(value || '')),
    );
    this.filteredDealCodeOptions = this.myDealControl.valueChanges.pipe(
      startWith(''),
      map((value:any) => this._filtersDeal(value || '')),
    );
  
  }
    objectToArray(obj: Record<string, string>): string[] {
      return Object.values(obj);
    }
selectItem(item: string) {
  this.selectedItem = item;
}
selectPerson(item: string) {
  this.selectedPerson = item;
}

totalPassengers: number = 1; // Initial total passengers






// Increment Adult



increment() {
  if (this.currentNumber+this.ccurrentNumber < 9) {
    this.currentNumber++;
    this.totalPassengers++;
    this.adult = this.currentNumber + " Adult";
  }
}

// Decrement Adult (At least 1 Adult must remain)
decrement() {
  if (this.currentNumber > 1) {
    this.currentNumber--;
    this.totalPassengers--;
    this.adult = this.currentNumber + " Adult";

    // Ensure infants do not exceed adults or max limit
    if (this.icurrentNumber > this.currentNumber || this.icurrentNumber > 4) {
      this.icurrentNumber = Math.min(this.currentNumber, 4);
      this.Infants = this.icurrentNumber + " Infants";
    }
  }
}

// Increment Children
cIncrement() {
  if (this.currentNumber+this.ccurrentNumber < 9) {
    this.ccurrentNumber++;
    this.totalPassengers++;
    this.child = this.ccurrentNumber + " Child";
  }
}

// Decrement Children
cDecrement() {
  if (this.ccurrentNumber > 0) {
    this.ccurrentNumber--;
    this.totalPassengers--;
    this.child = this.ccurrentNumber + " Child";
  }
}

// Increment Infants (Max 4 Infants, Cannot be more than Adults)
iIncrement() {
  if ( this.icurrentNumber < this.currentNumber && this.icurrentNumber < 4) {
    this.icurrentNumber++;
    this.totalPassengers++;
    this.Infants = this.icurrentNumber + " Infants";
  }
}

// Decrement Infants
iDecrement() {
  if (this.icurrentNumber > 0) {
    this.icurrentNumber--;
    this.totalPassengers--;
    this.Infants = this.icurrentNumber + " Infants";
  }}
// increment() {
//   if (this.totalPassengers < 9) {
//     this.currentNumber++;
//     this.totalPassengers++;
//     this.adult = this.currentNumber + " Adult";
//   }
// }

// // Decrement Adult (At least 1 Adult must remain)
// decrement() {
//   if (this.currentNumber > 1) {
//     this.currentNumber--;
//     this.totalPassengers--;
//     this.adult = this.currentNumber + " Adult";

//     // If infants exceed adults, adjust infants count
//     if (this.icurrentNumber > this.currentNumber) {
//       this.icurrentNumber =  Number(this.currentNumber);
//       this.Infants = this.icurrentNumber + " Infants";
//     }
//   }
// }

// // Increment Children
// cIncrement() {
//   if (this.totalPassengers < 9) {
//     this.ccurrentNumber++;
//     this.totalPassengers++;
//     this.child = this.ccurrentNumber + " Child";
//   }
// }

// // Decrement Children
// cDecrement() {
//   if (this.ccurrentNumber > 0) {
//     this.ccurrentNumber--;
//     this.totalPassengers--;
//     this.child = this.ccurrentNumber + " Child";
//   }
// }

// // Increment Infants (Cannot be more than Adults)
// iIncrement() {
//   if (this.totalPassengers < 9 && this.icurrentNumber < this.currentNumber) {
//     this.icurrentNumber++;
//     this.totalPassengers++;
//     this.Infants = this.icurrentNumber + " Infants";
//   }
// }

// // Decrement Infants
// iDecrement() {
//   if (this.icurrentNumber > 0) {
//     this.icurrentNumber--;
//     this.totalPassengers--;
//     this.Infants = this.icurrentNumber + " Infants";
//   }
// }
// increment() {
//   if (this.currentNumber < 9) {
//     this.currentNumber++;
//     this.adult=this.currentNumber+` `+"Adult"

//   } }
//   cIncrement() {
//   if (this.ccurrentNumber < 9) {
//     this.ccurrentNumber++;
//     this.child=this.ccurrentNumber+` `+"Child"
//   }}
//   iIncrement() {
//   if (this.icurrentNumber < 9) {
//     this.icurrentNumber++;
//     this.Infants=this.icurrentNumber+` `+"Infants"
//   } }

// decrement() {
//   if (this.currentNumber > 1) {
//     this.currentNumber--;
//     this.adult=this.currentNumber+` `+"Adult"

//   }}
//   cDecrement() {
//   if (this.ccurrentNumber > 0) {
//     this.ccurrentNumber--;
//     this.child=this.ccurrentNumber+` `+"Child"

//   }}
//   iDecrement() {
//   if (this.icurrentNumber > 0) {
//     this.icurrentNumber--;
//     this.Infants=this.icurrentNumber+` `+"Infants"

//   }
// }
  selectedDetail:boolean=false
  SelectDetail(){
    this.showMultiSearch=false

    this.selectedDetail=true

  }
  closeDetail(){

    this.selectedDetail=false

  }
  showMultiCityFlight(){
        this.showOneWay=false
        this.showReturn=false
        this.showMulti=true
  }
  showOneWayFlight(){
      this.dataFields()
      this.showMulti=false
      this.showReturn=false
      this.showOneWay=true
  }
  showReturnFlight(){
      this.dataReturnFields()
      this.showMulti=false
      this.showReturn=true
      this.showOneWay=false
  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    // Add our fruit
    if (value) {
      this.fruits.push(value);
    }

    // Clear the input value
    event.chipInput!.clear();

    this.fruitCtrl.setValue(null);
  }
  addTo(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    // Add our fruit
    if (value) {
      this.wherecity.push(value);
    }

    // Clear the input value
    event.chipInput!.clear();

    this.ToCtrl.setValue(null);
  }
  addM(event: MatChipInputEvent,item:any): void {
    const value = (event.value || '').trim();

    // Add our fruit
    if (value) {
      this.fruits.push(value);
    }

    // Clear the input value
    event.chipInput!.clear();

    item=null;
  }
  addMTo(event: MatChipInputEvent,item:any): void {
    const value = (event.value || '').trim();
    // Add our fruit
    if (value) {
      this.wherecity.push(value);
    }

    // Clear the input value
    event.chipInput!.clear();

    this.ToCtrl.setValue(null);
  }

  remove(fruit: string): void {
    const index = this.fruits.indexOf(fruit);

    if (index >= 0) {
      this.fruits.splice(index, 1);

      this.announcer.announce(`Removed ${fruit}`);
    }
  }
domInt:any={
  from:'India',
  to:'India'
}
  selected(event: MatAutocompleteSelectedEvent): void {

    
    this.fruits=event.option.viewValue;
    this.fromAirportError=false
  //  console.log(event.option.viewValue)
    this.fruitInput.nativeElement.value = event.option.viewValue;
    // this.fruitCtrl.setValue(null);
    this.departure=event.option.viewValue?.split(` `)[1]?.trim()?.split(',')[0]
// console.log(event.option.viewValue.split(` `)[1]?.trim()?.split(',')[1])
this.domInt.from=event.option.viewValue.split(` `)[1]?.trim()?.split(',')[1]
console.log(this.domInt.from)
  }
  selectedTo(event: MatAutocompleteSelectedEvent): void {
    this.wherecity=event.option.viewValue;
    this.toAirportError=false

    this.ToInput.nativeElement.value = event.option.viewValue;
    // this.ToCtrl.setValue(null);
    this.arrivel=event.option.viewValue?.split(` `)[1]?.trim()?.split(',')[0]

    this.domInt.to=event.option.viewValue.split(` `)[1]?.trim()?.split(',')[1]
    console.log(this.domInt.to)


  }


  selectedM(event: MatAutocompleteSelectedEvent,item:any): void {

 
    this.array.filter((array:any,index:any)=>{
      
      if(index==item){
        array.departure=event.option.viewValue?.split(` `)[1]?.trim()?.split(',')[0]
          }    })
  }
  selectedMTo(event: MatAutocompleteSelectedEvent,item:any): void {
    
    // this.arrivel=event.option.viewValue?.split(` `)[1]?.trim()?.split(',')[0]
this.array.forEach((array:any,index:any)=>{
  if(index==item){
    array.arrivel=event.option.viewValue?.split(` `)[1]?.trim()?.split(',')[0]
  }
})
   
    
  }

  private _filter(value: string): string[] {
    // Split the input value by comma and take the first part
    const filterValue = value.split(',')[0].toLowerCase().trim();
    // Use the filter method to create a new array containing only the matching fruits
    return this.allFruits.filter((fruit: any) => {
      // Split each fruit by comma and take the first part      console.log(Content)
      // fromAirportString?.split(` `)[1]?.trim()?.split(',')[0]
      let Content:any 
if(filterValue.includes('goa')){
  // let array:any=['GOI  Goa,India - Dabolim Airport','GOX  GOA,India - Manohar International Airport','GOA  Genoa,Italy - Genoa Cristoforo Colombo Airport']
  // return array
Content=fruit?.split(',')[0]?.toLowerCase()?.trim()?.split(` `)[0]+fruit?.split(',')[0]?.toLowerCase()?.trim()?.split(` `)[1]
}else{
      if(filterValue.split('').length>3){
         Content = fruit?.split(',')[0]?.toLowerCase()?.trim()?.split(` `)[1];
      }else{
        Content = fruit.split(',')[0]?.toLowerCase()?.trim().split(` `)[0];

      }}
      const Content1 = fruit.split(',')[1].toLowerCase().trim();
// console.log(Content)
      // Check if the lowercase fruit content includes the lowercase filterValue
     // return Content.includes(filterValue)||Content1.includes(filterValue);
    //  console.log(filterValue)
    //   console.log(Content)
      
      return Content?.includes(filterValue) 

    } );
  }
  private _filterTo(value: string): string[] {
    // Split the input value by comma and take the first part
    const filterValue = value.split(',')[0].toLowerCase().trim();
  
    // Use the filter method to create a new array containing only the matching fruits
    return this.whereTo.filter((fruit: any) => {
      // Split each fruit by comma and take the first part

      let whereTo:any 

      if(filterValue.includes('goa')){
  
        whereTo=fruit?.split(',')[0]?.toLowerCase()?.trim()?.split(` `)[1]+fruit?.split(',')[0]?.toLowerCase()?.trim()?.split(` `)[0]
        }else{
            if(filterValue.split('').length>3){
              whereTo = fruit?.split(',')[0]?.toLowerCase()?.trim()?.split(` `)[1];
      
            }else{
              whereTo = fruit?.split(',')[0]?.toLowerCase()?.trim()?.split(` `)[0];
      
            }
          }



      const whereTo1 = fruit.split(',')[1].toLowerCase().trim();

      // Check if the lowercase fruit content includes the lowercase filterValue
      // console.log(whereTo?.includes(filterValue))
      return whereTo?.includes(filterValue) 
    } );
  }
  // private _filterTo(value: string): string[] {
  //   const filterValue = value.toLowerCase(); 
  //   return this.whereTo.filter((airport: any) => airport.toLowerCase().includes(filterValue));
  // }

  getFlightList(){
   
    this.FlightService
    .getFlightList()
    .subscribe({
      next : (res:any) => {
        this.allFruits=[]
          this.whereTo=[]
       
        if(res) {
         let data:any
         const allowedCodes = ['BOM', 'DEL', 'BLR', 'PNQ','CCU',"GOI","HYD","MAA","RAJ"];

         const first = res.filter((item:any) => allowedCodes.includes(item.iataCode));
         const last = res.filter((item:any) => allowedCodes.every(code => item.iataCode !== code));
         data=[...first,...last]

         for (let i = 0; i < data.length; i++) {

          this.allFruits.push(data[i].iataCode+`\u00A0 `+data[i].city.replace(' ','')+`,`+data[i].country+` - `+data[i].name);
          this.whereTo.push(data[i].iataCode+`\u00A0 `+data[i].city.replace(' ','')+`,`+data[i].country+` - `+data[i].name);

          this.array.forEach((item:any)=>{
            item.whereFrom.push(data[i].iataCode+`\u00A0 `+data[i].city.replace(' ','')+`,`+data[i].country+` - `+data[i].name);
            item.whereTo.push(data[i].iataCode+`\u00A0 `+data[i].city.replace(' ','')+`,`+data[i].country+` - `+data[i].name);
          })
         }
        if(this.searchData?.airSearchRequestBaseDetails){

          if(this.searchData?.airSearchRequestBaseDetails.length>1){

          this.array=[]
          for (let i = 0; i < this.searchData?.airSearchRequestBaseDetails.length; i++) {
            let from:any=data.filter((itm:any)=>itm?.iataCode===this.searchData?.airSearchRequestBaseDetails[i]?.fromAirport);
            let to:any=data.filter((itm:any)=>itm?.iataCode===this.searchData?.airSearchRequestBaseDetails[i]?.toAirport);
let array:any={
  'whereFrom': [],
  'whereTo': [],
  "requestedDate":new Date(this.searchData?.airSearchRequestBaseDetails[i].requestedDate),
  "requestedClass": this.searchData?.airSearchRequestBaseDetails[i].requestedClass,
  "fromAirport": new FormControl(from[0].iataCode+`\u00A0 `+from[0].city+`,`+from[0].country+` - `+from[0].name),
  "toAirport":new FormControl(to[0].iataCode+`\u00A0 `+to[0].city+`,`+to[0].country+` - `+to[0].name),
  "departureTime": this.dateFormate(this.searchData?.airSearchRequestBaseDetails[i].requestedDate.split(' '))?.split(' '),
  "departure":from[0].city,
  'arrivel':to[0].city,
  'min':this.minData,
  'filteredFrom':Observable<string[]>,
  'filteredTo':Observable<string[]>
}

this.array.push(array)}
for (let i = 0; i < data.length; i++) {
  this.array.forEach((item:any)=>{
    item.whereFrom.push(data[i].iataCode+`\u00A0 `+data[i].city+`,`+data[i].country+` - `+data[i].name);
    item.whereTo.push(data[i].iataCode+`\u00A0 `+data[i].city+`,`+data[i].country+` - `+data[i].name);
  })
 }

 this.array.forEach((item:any)=>{
    
  item.filteredFrom=item.fromAirport.valueChanges.pipe(
    debounceTime(300), // Adjust the debounce time as needed
    distinctUntilChanged(),
    startWith(null),
    map((airport: any | null) => (airport ? this._filter(airport) : item.whereFrom.slice())),
  );

  item.filteredTo = item.toAirport.valueChanges.pipe(
    debounceTime(300), // Adjust the debounce time as needed
    distinctUntilChanged(),
    startWith(null),
    map((airports: any | null) => (airports ? this._filterTo(airports) : item.whereTo.slice())),
  );

})


          }
          const  fromAirportDataRaw = data.filter((itm:any)=>itm?.iataCode===this.searchData?.airSearchRequestBaseDetails[0]?.fromAirport);

          let fromAirportData = fromAirportDataRaw[0];
        let fromAirportString:any = fromAirportData?.iataCode+`\u00A0 `+fromAirportData?.city+`,`+fromAirportData?.country+` - `+fromAirportData?.name
        if( this.fruitInput){
          this.fruitInput.nativeElement.value =   fromAirportString     //toAirData={option:{viewValue:toAirData}}

        }
        this.fruits=fromAirportString;
        // this.fruitCtrl.setValue(null);
        // console.log( this.fruits)

        const  toAirportDataRaw = data.filter((itm:any)=>itm.iataCode===this.searchData.airSearchRequestBaseDetails[0].toAirport);
        let toAirportData = toAirportDataRaw[0];
        let toAirportString = toAirportData?.iataCode+`\u00A0 `+toAirportData?.city+`,`+toAirportData?.country+` - `+toAirportData?.name
        if( this.ToInput){
          this.ToInput.nativeElement.value =   toAirportString     //toAirData={option:{viewValue:toAirData}}

        }
        this.wherecity=toAirportString;
        this.departure= fromAirportString?.split(` `)[1]?.trim()?.split(',')[0]
        this.arrivel=toAirportString?.split(` `)[1]?.trim()?.split(',')[0]
        // this.ToCtrl.setValue(null);
         }else{
            this.wherecity="BOM  Mumbai,India - Chhatrapati Shivaji International Airport"
          this.fruits="DEL  Delhi,India - Indira Gandhi International Airport"
          if( this.ToInput){
            this.ToInput.nativeElement.value="BOM  Mumbai,India - Chhatrapati Shivaji International Airport"

          }
          if( this.fruitInput){
            this.fruitInput.nativeElement.value="DEL  Delhi,India - Indira Gandhi International Airport"

          }
          this.departure="Delhi"
          this.arrivel="Mumbai"
         }

         for (let i = 0; i < this.array.length; i++) {
          const currentItem = this.array[i];
      
          // Step 3: Set min date
          if (i === 0) {
            // First item: min = today (or some default)
            
            currentItem.min = new Date();
            if(this.isActive('/app/create-manual-cart')){
              currentItem.min = '';

            }
          } else {
            const previousItem = this.array[i - 1];
            const newMinDate = this.datePlus(previousItem.requestedDate);
            currentItem.min = newMinDate;
      
            // If requestedDate is invalid (less than min), update it
            if (new Date(currentItem.requestedDate) < newMinDate) {
              currentItem.requestedDate = newMinDate;
            }
          }
      
          // Step 4: Update departureTime for every item
          if (currentItem?.requestedDate) {
            currentItem.departureTime = this.dateFormate(currentItem.requestedDate)?.split(' ');
          }
        }
        
       
        } else {    
        } 
      },error : (err) => {

        
      }
    }
  )
  }
 

uuids:any=[]
  searchClick(){
    let date:any=new Date().getDate();

    // console.log(date)
    let uu:any
    // console.log(uu)

    this.uuids.push(this.generateUUIDv4())
    // console.log(this.uuids)

   
  }
  generateUUIDv4(): string {
    let date:any=new Date().getDate();
    let time:any=new Date().getTime();
    let uuidDate:any=date+time;
    // console.log(date+"t"+time)
    return uuidDate+'-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
//   searchFlight(){
//     //this.route.navigate(["/app/Flightlist"]);}
//  window.location.href="/app/Flightlist"
//   }

  dataFields(){
    const originalDate = new Date();
    const newDate = new Date(originalDate.setDate(originalDate.getDate() + 3));

    // const originalTimestamp =newDate;
    // const datePipe = new DatePipe('en-IN');

    // const newTimestamp = datePipe.transform(originalTimestamp, 'yyyy-MM-ddTHH:00:00.000Z');


    this.arrivelTime=''
    this.searchFg=this.fb.group({
      "fromAirport" :  ['',[Validators.required]],
      "toAirport" : [,[Validators.required]],
      "requestedDate":[newDate],
      "requestedClass":[''],
      "paxCount":[0],
      "adultCount":[0],
      "childCount":[0],
      "infantCount":[0],
      "returnDate":[],
      "menu":['oneWay']
    });
if(this.searchFg?.value?.requestedDate){
    this.departureTime=this.dateFormate(this.searchFg?.value?.requestedDate)?.split(' ')
  }
  
  // console.log(this.searchFg?.value?.requestedDate)

  }
 

  dateFormate(date:any){
    const parsedDate = new Date(date);
    const datePipe = new DatePipe('en-IN');
    date = datePipe.transform(parsedDate, 'd MMM yyyy EEEE');
    // date = datePipe.transform(parsedDate, 'EEE dd MMM yyyy');
return date

  }
  convertToISOStringFormat(dateString:any) {
    // Remove the ' 00:00' part and then add 'Z' at the end
    const isoDateString = dateString.replace('00.000 00:00', '00.000Z');
    return isoDateString;
  }
  areDatesEqual(date1: Date, date2: Date): boolean {
    // Compare year, month, and day to check if the dates are equal
    return date1.getFullYear() === date2.getFullYear() &&
           date1.getMonth() === date2.getMonth() &&
           date1.getDate() === date2.getDate();
  }
  onChangeDate(){
  //  this.searchFg.value.returnDate=this.datePlus(this.searchFg.value.requestedDate)
   // if(this.searchFg.value.menu==='return'){
    if(this.searchFg.value.requestedDate){
      let date:any=new Date();
      if (this.areDatesEqual(this.searchFg.value.requestedDate, date)) {
        // Your code for the condition when dates are the same
        this.searchFg.value.requestedDate=new Date()
      } else {
        // Your code for the condition when dates are not the same
      }
    }
     
    this.searchFg=this.fb.group({
      "fromAirport" :  [this.searchFg.value.fromAirport,[Validators.required]],
      "toAirport" : [this.searchFg.value.toAirport,[Validators.required]],
      "requestedDate":[ this.searchFg.value.requestedDate],
      "requestedClass":[ this.searchFg.value.requestedClass],
      "paxCount":[this.searchFg.value.paxCount],
      "adultCount":[this.searchFg.value.adultCount],
      "childCount":[this.searchFg.value.childCount],
      "infantCount":[this.searchFg.value.infantCount],
      "returnDate":[this.searchFg.value.requestedDate],
      "menu":[]
    });
    // this.date1Plus()
  }
  onMultiDate(element: any, item: number) {
    // Step 1: Update the current item's departureTime
    if (element?.requestedDate) {
      element.departureTime = this.dateFormate(element.requestedDate)?.split(' ');
    }
  
    // Step 2: Loop over the entire array to fix min and requestedDate
    for (let i = 0; i < this.array.length; i++) {
      const currentItem = this.array[i];
  
      // Step 3: Set min date
      if (i === 0) {
        // First item: min = today (or some default)
        currentItem.min = new Date();
      } else {
        const previousItem = this.array[i - 1];
        const newMinDate = this.datePlus(previousItem.requestedDate);
        currentItem.min = newMinDate;
  
        // If requestedDate is invalid (less than min), update it
        if (new Date(currentItem.requestedDate) < newMinDate) {
          currentItem.requestedDate = newMinDate;
        }
      }
  
      // Step 4: Update departureTime for every item
      if (currentItem?.requestedDate) {
        currentItem.departureTime = this.dateFormate(currentItem.requestedDate)?.split(' ');
      }
    }
  }
  
  onOneWayDate(){
    if(this.searchFg?.value?.requestedDate){
      this.departureTime=this.dateFormate(this.searchFg?.value?.requestedDate)?.split(' ')
    }
   
    if(this.searchFg.value.requestedDate){
      let date:any=new Date();
      if (this.areDatesEqual(this.searchFg.value.requestedDate, date)){
        // Your code for the condition when dates are the same
        this.searchFg.value.requestedDate=new Date()
      } else {
        // Your code for the condition when dates are not the same
      }
    }
      
    console.log('12w')
    if (this.searchFg.get('returnDate')?.value) {
          console.log('12F')

      const returnDate = new Date(this.searchFg.get('returnDate')?.value);
      const requestedDate = new Date(this.searchFg.get('requestedDate')?.value);
    
      if ( requestedDate > returnDate) {
        console.log('12dF')

        const newReturnDate = this.datePlus(requestedDate);
        this.searchFg.get('returnDate')?.setValue(newReturnDate);
          this.arrivelTime=this.dateFormate(this.searchFg?.value?.returnDate)?.split(' ')
        
        
      }
    }
    this.searchFg=this.fb.group({
      "fromAirport" :  [this.searchFg?.value?.fromAirport,[Validators.required]],
      "toAirport" : [this.searchFg?.value?.toAirport,[Validators.required]],
      "requestedDate":[ this.searchFg?.value?.requestedDate],
      "requestedClass":[ this.searchFg?.value?.requestedClass],
      "paxCount":[this.searchFg?.value?.paxCount],
      "adultCount":[this.searchFg?.value?.adultCount],
      "childCount":[this.searchFg?.value?.childCount],
      "infantCount":[this.searchFg?.value?.infantCount],
      "returnDate":[this.searchFg?.value?.returnDate],
      "menu":[this.searchFg?.value?.menu]

    });

    
  }

  onRChangeDate(){
    this.showReturn=true
    this.showOneWay=true

    if(this.searchFg?.value?.returnDate){
      let date:any=new Date();
      if (this.areDatesEqual(this.searchFg.value.returnDate, date)) {
        // Your code for the condition when dates are the same
        this.searchFg.value.returnDate=new Date()
      } else {
        // Your code for the condition when dates are not the same
      }
  
    
     }
    this.searchFg=this.fb.group({
      "fromAirport" :  [this.searchFg?.value?.fromAirport,[Validators.required]],
      "toAirport" : [this.searchFg?.value?.toAirport,[Validators.required]],
      "requestedDate":[ this.searchFg?.value?.requestedDate],
      "requestedClass":[ this.searchFg?.value?.requestedClass],
      "paxCount":[this.searchFg?.value?.paxCount],
      "adultCount":[this.searchFg?.value?.adultCount],
      "childCount":[this.searchFg?.value?.childCount],
      "infantCount":[this.searchFg?.value?.infantCount],
      "returnDate":[this.searchFg?.value?.returnDate],
      "menu":["return"]
    });
    if(this.searchFg?.value?.returnDate){
      this.arrivelTime=this.dateFormate(this.searchFg?.value?.returnDate)?.split(' ')
    }
  }
  dataReturnFields(){

  
    this.searchFg=this.fb.group({
      "fromAirport" :  [this.searchFg?.value?.fromAirport,[Validators.required]],
      "toAirport" : [this.searchFg?.value?.toAirport,[Validators.required]],
      "requestedDate":[this.searchFg?.value?.requestedDate],
      "requestedClass":[this.searchFg?.value?.requestedClass],
      "paxCount":[0],
      "adultCount":[0],
      "childCount":[0],
      "infantCount":[0],
      "returnDate":[ this.searchFg.value.requestedDate],
      "menu":['return']
    });
    // this.date1Plus()
    if(this.searchFg?.value?.returnDate){
      this.arrivelTime=this.dateFormate(this.searchFg?.value?.returnDate)?.split(' ')
    }
  }
  
  fromAirportError:boolean=false
  toAirportError:boolean=false
  bookingType:any='C'
  searchFlight() {
    // if(this.searchData.travelType){
    //   console.log(this.searchData.travelType)
    // this.travelType=this.searchData.travelType
    // if(this.travelType==='AD'){
    //   this.domInt.to='India'
    //   this.domInt.from='India'
    // }}else{
    //   if(this.travelType==='AD'){
    //     this.domInt.to='India'
    //     this.domInt.from='India'
    //   }
    // }
    this.selectedDetail=false
    this.showMultiSearch=false

    //console.log(this.searchFg.value.requestedDate)
    this.searchFg.value.childCount=this.ccurrentNumber
    this.searchFg.value.adultCount=this.currentNumber
    this.searchFg.value.infantCount=this.icurrentNumber
    this.searchFg.value.paxCount=this.searchFg.value.childCount+this.searchFg.value.adultCount
    if(this.selectedItem==='Economy'){
      
      this.searchFg.value.requestedClass="Y"

    }
    if(this.selectedItem==='First'){
      
      this.searchFg.value.requestedClass="F"

    }
    if(this.selectedItem==='Business'){
      
      this.searchFg.value.requestedClass="C"

    }
    if(this.selectedItem==='Premium Economy'){
      
      this.searchFg.value.requestedClass="W"

    }
    this.searchFg.value.toAirport= this.wherecity?.split(` `)[0].trim()
    this.searchFg.value.fromAirport=this.fruits?.split(` `)[0].trim()
   if(this.searchFg.value.requestedDate){
    // const parsedDate = new Date(this.searchFg.value.requestedDate);

    // // Adjust the timezone offset to convert to UTC
    // const utcDate = new Date(parsedDate.getTime() - (parsedDate.getTimezoneOffset() * 60000));

    // // Format the date as ISO 8601
    // this.searchFg.value.requestedDate = utcDate.toISOString();
    // console.log(this.searchFg.value.requestedDate)
  }


    if(this.searchFg.value.returnDate){
      // const parsedDate = new Date(this.searchFg.value.returnDate);
      
      // // Adjust the timezone offset to convert to UTC
      // const utcDate = new Date(parsedDate.getTime() - (parsedDate.getTimezoneOffset() * 60000));

      // // Format the date as ISO 8601
      // this.searchFg.value.returnDate = utcDate.toISOString();
      // console.log(this.searchFg.value.returnDate)
    }

     if(this.searchFg.value.fromAirport==="" ||this.searchFg.value.fromAirport===undefined ||this.searchFg.value.toAirport==="" ||this.searchFg.value.toAirport===undefined ||this.searchFg.value.requestedDate===""||this.searchFg.value.requestedDate===undefined ){
      this.toastMsgService.setMsg({msg : "Please select the compulsory field ",msgTitle:  "Warning", msgType : "W"});
     if(this.searchFg.value.fromAirport==="" ||this.searchFg.value.fromAirport===undefined){
      this.fromAirportError=true
     }
     if(this.searchFg.value.toAirport==="" ||this.searchFg.value.toAirport===undefined){
      this.toAirportError=true
     }
     

    }else{
      let data:any
      // console.log(this.searchFg.value.returnDate)
      // if(this.searchFg.value.returnDate===null ||this.searchFg.value.returnDate===undefined||this.searchFg.value.returnDate===""){
        if(this.searchFg.value.menu==='oneWay'){
         if(this.domInt.to==='India'&&this.domInt.from==='India'){
          this.travelType='AD'
         }else{
          this.travelType='AI'

         }


        // const inputDateTime = this.searchFg.value.requestedDate;
        // const datePipe = new DatePipe('en-IN');

        // let formattedDateTime:any = datePipe.transform(inputDateTime, 'yyyy-MM-ddTHH:mm:ss.SSSZ');
        // this.searchFg.value.requestedDate = formattedDateTime; 
      data ={
        
        "airSearchRequestBaseDetails": [
            {
                "requestedDate":this.convertTimeZone(this.searchFg.value.requestedDate),
                "requestedClass": this.searchFg.value.requestedClass,
                "fromAirport": this.searchFg.value.fromAirport,
                "toAirport": this.searchFg.value.toAirport
            }
           
        ],
        journeyType:"oneWay",

        "paxCount":this.searchFg.value.paxCount,
        "adultCount": this.searchFg.value.adultCount,
        "childCount": this.searchFg.value.childCount,
        "infantCount": this.searchFg.value.infantCount
    }
   
  
if(this.isActive('/app/create-manual-cart')){
  sessionStorage.setItem('retrivePnr','false')

  this.uuids=this.generateUUIDv4()
  data.requestId=this.uuids
  data.uuid=this.uuids
  data.travelType=this.travelType
  data.directFlight=this.directFlight
  data.dealCode=this.dealCode
  data.prefAirline=this.prefAirline
  data.username=this.userName
  data.pointerEvents=false
data.userBookingContext=this.bookingType
  this.data.deliverMsg(data)
  this.myOutput.emit(this.outputMessage);
this.generatePnr=true
}else{
  this.uuids=this.generateUUIDv4()
  data.requestId=this.uuids
  data.uuid=this.uuids
  data.travelType=this.travelType
  data.directFlight=this.directFlight
  data.dealCode=this.dealCode
  data.prefAirline=this.prefAirline
  data.pointerEvents=false
  data.userBookingContext=this.bookingType
  data.countryTo=this.domInt.to
  data.countryFrom=this.domInt.from
  this.data.deliverMsg(data)
  this.myOutput.emit(this.outputMessage);
  this.route.navigate(["/app/flightlist"]);

}

    }else if(this.searchFg.value.menu==='multiCity'){
      this.array.forEach((item:any)=>{
        item.requestedClass=this.searchFg.value.requestedClass
      }
      )

      let array:any=[]
      const from = this.array.some((item:any) => item.fromAirport.value?.split(` `)[1]?.trim()?.split(',')[1] != 'India');
      const to = this.array.some((item:any) => item.toAirport.value?.split(` `)[1]?.trim()?.split(',')[1] != 'India');
      if(from||to){
        this.travelType='AI'
       }else{
        this.travelType='AD'

       }
     
   // Default value if 'intl' is not found

      for(let i=0;i<this.array.length;i++){

let arrayJson={
  'requestedDate':this.convertTimeZone(this.array[i]?.requestedDate),
  'requestedClass':this.array[i].requestedClass,
 'fromAirport':this.array[i].fromAirport?.value?.split(` `)[0].trim(),
  'toAirport':this.array[i].toAirport?.value?.split(` `)[0].trim(),
}
array.push(arrayJson)
       
      }
      console.log(array)


      data ={
        "airSearchRequestBaseDetails":array,
        journeyType:"multiCity",
        "paxCount":this.searchFg.value.paxCount,
        "adultCount": this.searchFg.value.adultCount,
        "childCount": this.searchFg.value.childCount,
        "infantCount": this.searchFg.value.infantCount
    }
   

    if(this.isActive('/app/create-manual-cart')){
      sessionStorage.setItem('retrivePnr','false')

      this.uuids=this.generateUUIDv4()
      data.requestId=this.uuids
      data.uuid=this.uuids
      data.directFlight=this.directFlight
      data.dealCode=this.dealCode
      data.prefAirline=this.prefAirline
      data.travelType=this.travelType
      data.pointerEvents=false
      data.userBookingContext=this.bookingType


      data.username=this.userName
      this.data.deliverMsg(data)
      this.myOutput.emit(this.outputMessage);
      
      this.generatePnr=true

    }else{
      this.uuids=this.generateUUIDv4()
      data.requestId=this.uuids
      data.uuid=this.uuids
      data.directFlight=this.directFlight
      data.dealCode=this.dealCode
      data.prefAirline=this.prefAirline
      data.travelType=this.travelType
      data.pointerEvents=false
      data.userBookingContext=this.bookingType
      this.data.deliverMsg(data)
      this.myOutput.emit(this.outputMessage);
      // this.route.navigate(["/app/flightList"]);
      if(this.travelType==='AI'){
        this.route.navigate(["/app/flight-intl-list"]);
        // this.route.navigate(["/app/flightList"]);

      }else{
        this.route.navigate(["/app/flightList"]);

      }
    
    }


    } else if(this.searchFg.value.menu==='return'){
      
     console.log(this.domInt)
        if(this.domInt.to==='India'&&this.domInt.from==='India'){

         this.travelType='AD'
        //  if(this.searchData.travelType){
        //   this.travelType=this.searchData.travelType
        //  }
         

        }else{
         this.travelType='AI'

        }

      
      data ={
        "airSearchRequestBaseDetails": [
            {
                "requestedDate":this.convertTimeZone(this.searchFg.value.requestedDate),
                "requestedClass": this.searchFg.value.requestedClass,
                "fromAirport": this.searchFg.value.fromAirport,
                "toAirport": this.searchFg.value.toAirport
            },
            {
              "requestedDate":this.convertTimeZone(this.searchFg.value.returnDate),
              "requestedClass": this.searchFg.value.requestedClass,
              "fromAirport": this.searchFg.value.toAirport,
              "toAirport": this.searchFg.value.fromAirport
          },
          
        ],
        journeyType:"return",
        "paxCount":this.searchFg.value.paxCount,
        "adultCount": this.searchFg.value.adultCount,
        "childCount": this.searchFg.value.childCount,
        "infantCount": this.searchFg.value.infantCount
    }
    

   

    if(this.isActive('/app/create-manual-cart')){
      sessionStorage.setItem('retrivePnr','false')

      this.uuids=this.generateUUIDv4()
    data.requestId=this.uuids
    data.uuid=this.uuids
    data.directFlight=this.directFlight
    data.dealCode=this.dealCode
    data.prefAirline=this.prefAirline
    data.travelType=this.travelType
    data.username=this.userName
    data.pointerEvents=false
    data.userBookingContext=this.bookingType
    this.data.deliverMsg(data)
    this.myOutput.emit(this.outputMessage);
      this.generatePnr=true

    }else{
      this.uuids=this.generateUUIDv4()
      data.requestId=this.uuids
      data.uuid=this.uuids
      data.directFlight=this.directFlight
      data.dealCode=this.dealCode
      data.prefAirline=this.prefAirline
      data.travelType=this.travelType
      data.pointerEvents=false
      data.userBookingContext=this.bookingType
      data.countryTo=this.domInt.to
      data.countryFrom=this.domInt.from
      this.data.deliverMsg(data)
      this.myOutput.emit(this.outputMessage);

      // console.log(this.travelType)
      if(this.travelType==='AI'){
        this.route.navigate(["/app/flight-intl-list"]);
        // this.route.navigate(["/app/flightList"]);


      }else{
        this.route.navigate(["/app/flightList"]);

      }
    
    }
    }
    
    // console.log(data)
   
  }

   
  }

  date1Plus(item:any)
{
  const originalDate = new Date(item);
  const newDate = new Date(originalDate.setDate(originalDate.getDate() + 1));
  return newDate
} 
datePlus(item:any)
{
  const originalDate = new Date(item);
  const newDate = new Date(originalDate.setDate(originalDate.getDate()));
  return newDate
} 
clearCity:boolean=false
AddCity:boolean=false
array:any=[ {
  "requestedDate":new Date(new Date().setDate(new Date().getDate() + 3)),
  "requestedClass": '',
  "fromAirport": new FormControl('DEL  Delhi,India - Indira Gandhi International Airport'),
  "toAirport":new FormControl('BOM  Mumbai,India - Chhatrapati Shivaji International Airport'),
  "departureTime":this.dateFormate(new Date(new Date().setDate(new Date().getDate() + 3)))?.split(' '),
  "departure":'Delhi',
  'arrivel':'Mumbai',
  'whereFrom':[],
  'whereTo':[],
  'filteredFrom':Observable<string[]>,
  'filteredTo':Observable<string[]>,
  'min':this.minData,


},{
  "requestedDate":new Date(new Date().setDate(new Date().getDate() + 4)),
  "requestedClass": '',
  "fromAirport": new FormControl('BOM  Mumbai,India - Chhatrapati Shivaji International Airport'),
  "toAirport":new FormControl(''),
  "departureTime":this.dateFormate(new Date(new Date().setDate(new Date().getDate() + 4)))?.split(' '),
  "departure":'Mumbai',
  'arrivel':'',
  'whereFrom':[],
  'whereTo':[],
  'filteredFrom':Observable<string[]>,
  'filteredTo':Observable<string[]>,
  'min':this.minData,

},]
clickMulticity(){
  
 let count:any={
  
  "requestedDate":'',
  "requestedClass": '',
  "fromAirport": new FormControl(''),
  "toAirport":new FormControl(''),
  "departureTime":'',
  "departure":'',
  'arrivel':'',
  'whereFrom':[],
  'whereTo':[],
  'filteredFrom':Observable<string[]>,
  'filteredTo':Observable<string[]>
}


let where=["BOM  Mumbai,India - Chhatrapati Shivaji International Airport","GOI  Goa,India - Dabolim Airport","PNQ  Pune,India - Pune Airport","DEL  Delhi,India - Indira Gandhi International Airport","BLR  Bangalore,India - Kempegowda International Airport","CCU  Kolkata,India - Netaji Subhash Chandra Bose International Airport","HYD  Hyderabad,India - Rajiv Gandhi International Airport","MAA  Madras,India - Chennai International Airport","RAJ  Rajkot,India - Rajkot Airport"]


this.array.push(count)
this.array.forEach((item:any)=>{
    item.filteredFrom=item.fromAirport.valueChanges.pipe(
    debounceTime(300), // Adjust the debounce time as needed
    distinctUntilChanged(),
    startWith(null),
    map((airport: any | null) => (airport ? this._filter(airport) : where.slice())),
  );

  item.filteredTo = item.toAirport.valueChanges.pipe(
    debounceTime(300), // Adjust the debounce time as needed
    distinctUntilChanged(),
    startWith(null),
    map((airports: any | null) => (airports ? this._filterTo(airports) : where.slice())),
  );

})
// console.log(this.array)
if(this.array.length>3){
this.AddCity=true
}else{
  this.AddCity=false
}
if(this.array.length>2){
  this.clearCity=true
  }else{
    this.clearCity=false
  
  }

  for (let i = 0; i < this.array.length; i++) {
    const currentItem = this.array[i];

    // Step 3: Set min date
    if (i === 0) {
      // First item: min = today (or some default)
      currentItem.min = new Date();
    } else {
      const previousItem = this.array[i - 1];
      const newMinDate = this.datePlus(previousItem.requestedDate);
      currentItem.min = newMinDate;

      // If requestedDate is invalid (less than min), update it
      if (new Date(currentItem.requestedDate) < newMinDate) {
        currentItem.requestedDate = newMinDate;
      }
    }

    // Step 4: Update departureTime for every item
    if (currentItem?.requestedDate) {
      currentItem.departureTime = this.dateFormate(currentItem.requestedDate)?.split(' ');
    }
  }
}
clear(){
  this.AddCity=false

  if(this.array.length>3){
    this.clearCity=true
    }else{
      this.clearCity=false
    
    }
  this.array.splice(this.array.length-1, 1);

}
showPnrRetrieval:boolean=false
onMenuChange(event:any){
  this.showMultiSearch=false
  if(event.value==="oneWay"){
    this.arrivelTime=''
    this.searchFg=this.fb.group({
      "fromAirport" :  [ this.searchFg?.value?.fromAirport,[Validators.required]],
      "toAirport" : [this.searchFg?.value?.toAirport,[Validators.required]],
      "requestedDate":[this.searchFg?.value?.requestedDate],
      "requestedClass":[''],
      "paxCount":[0],
      "adultCount":[0],
      "childCount":[0],
      "infantCount":[0],
      "returnDate":[],
      "menu":['oneWay']
    });
if(this.searchFg?.value?.requestedDate){
    this.departureTime=this.dateFormate(this.searchFg?.value?.requestedDate)?.split(' ')
  }
    //this.searchFg.value.menu="oneWay"
    this.showMulti=false
    this.showReturn=true
    this.showOneWay=true
    this.showPnrRetrieval=false
  }else if(event.value==="return")
{
  //this.searchFg.value.menu="return"
  this.dataReturnFields()
  this.showMulti=false
  this.showReturn=true
  this.showOneWay=true
  this.showPnrRetrieval=false

}else if(event.value==="multiCity")
{
  this.searchFg=this.fb.group({
    "fromAirport" :  [ this.searchFg?.value?.fromAirport,[Validators.required]],
    "toAirport" : [this.searchFg?.value?.toAirport,[Validators.required]],
    "requestedDate":[this.searchFg?.value?.requestedDate],
    "requestedClass":[''],
    "paxCount":[0],
    "adultCount":[0],
    "childCount":[0],
    "infantCount":[0],
    "returnDate":[],
    "menu":['multiCity']
  });
  this.showOneWay=false
  this.showReturn=false
  this.showMulti=true
  this.showPnrRetrieval=false

}
else if(event.value==="pnrRetrieval"){
  this.showOneWay=false
  this.showReturn=false
  this.showMulti=false
  this.showPnrRetrieval=true

}

}




isActive(route: string): boolean {
  return this.route.isActive(route, true);
}
showArrivel:boolean=false
openAutocomplete(): void {
  this.showArrivel=true
  let whereTo=["BOM  Mumbai,India - Chhatrapati Shivaji International Airport","GOI  Goa,India - Dabolim Airport","PNQ  Pune,India - Pune Airport","DEL  Delhi,India - Indira Gandhi International Airport","BLR  Bangalore,India - Kempegowda International Airport","CCU  Kolkata,India - Netaji Subhash Chandra Bose International Airport","HYD  Hyderabad,India - Rajiv Gandhi International Airport","MAA  Madras,India - Chennai International Airport","RAJ  Rajkot,India - Rajkot Airport"]

  // Check if mat-autocomplete is defined
  this.filteredTo = this.ToCtrl.valueChanges.pipe(
    debounceTime(300), // Adjust the debounce time as needed
    distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)),
    startWith(null),
    map((airports: any | null) => (airports ? this._filterTo(airports) : whereTo.slice())),
  );

    this.ToCtrl.setValue(null);
    this.arrivel=null
    this.renderer.selectRootElement(this.ToInput.nativeElement).focus();

    // this.ToCtrl.setValue(this.ToInput.nativeElement.value);

  



}
openDAutocomplete(){
  let allFruits=["BOM  Mumbai,India - Chhatrapati Shivaji International Airport","GOI  Goa,India - Dabolim Airport","PNQ  Pune,India - Pune Airport","DEL  Delhi,India - Indira Gandhi International Airport","BLR  Bangalore,India - Kempegowda International Airport","CCU  Kolkata,India - Netaji Subhash Chandra Bose International Airport","HYD  Hyderabad,India - Rajiv Gandhi International Airport","MAA  Madras,India - Chennai International Airport","RAJ  Rajkot,India - Rajkot Airport"]

  this.filteredFruits = this.fruitCtrl.valueChanges.pipe(
    debounceTime(300), // Adjust the debounce time as needed
    distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)),
    startWith(null),
    map((airport: any | null) => (airport ? this._filter(airport) : allFruits.slice())),
  );
  
  
  // Check if mat-autocomplete is defined

    this.fruitCtrl.setValue(null);
    this.departure=null
    this.renderer.selectRootElement(this.fruitInput.nativeElement).focus();

}



openAutoMcomplete(item:any): void {
  item.formAirport=new FormControl(' ')
  let where=["BOM  Mumbai,India - Chhatrapati Shivaji International Airport","GOI  Goa,India - Dabolim Airport","PNQ  Pune,India - Pune Airport","DEL  Delhi,India - Indira Gandhi International Airport","BLR  Bangalore,India - Kempegowda International Airport","CCU  Kolkata,India - Netaji Subhash Chandra Bose International Airport","HYD  Hyderabad,India - Rajiv Gandhi International Airport","MAA  Madras,India - Chennai International Airport","RAJ  Rajkot,India - Rajkot Airport"]
  item.filteredFrom=item.fromAirport.valueChanges.pipe(
    debounceTime(300), // Adjust the debounce time as needed
    distinctUntilChanged(),
    startWith(null),
    map((airport: any | null) => (airport ? this._filter(airport) : where.slice())),
  );

  // this.showArrivel=true
  // Check if mat-autocomplete is defined
    item.fromAirport.setValue(null);
    item.departure=null
    // this.renderer.selectRootElement(fromAirport).focus();

    // this.ToCtrl.setValue(this.ToInput.nativeElement.value);

  



}


openDAutoMcomplete(item:any){
  // console.log(this.inputRefs)
  // Check if mat-autocomplete is defined
  let where=["BOM  Mumbai,India - Chhatrapati Shivaji International Airport","GOI  Goa,India - Dabolim Airport","PNQ  Pune,India - Pune Airport","DEL  Delhi,India - Indira Gandhi International Airport","BLR  Bangalore,India - Kempegowda International Airport","CCU  Kolkata,India - Netaji Subhash Chandra Bose International Airport","HYD  Hyderabad,India - Rajiv Gandhi International Airport","MAA  Madras,India - Chennai International Airport","RAJ  Rajkot,India - Rajkot Airport"]
  item.filteredTo=item.toAirport.valueChanges.pipe(
    debounceTime(300), // Adjust the debounce time as needed
    distinctUntilChanged(),
    startWith(null),
    map((airport: any | null) => (airport ? this._filter(airport) : where.slice())),
  );
  item.toAirport.setValue(null);
  item.arrivel=null
    //  this.renderer.selectRootElement(this.inputRefs).focus();

     

}
convertTimeZone(input:any){
  console.log()
  const inputDateTime = input;
  const datePipe = new DatePipe('en-IN');

  let formattedDateTime:any = datePipe.transform(inputDateTime, 'yyyy-MM-ddTHH:mm:ss.SSSZ');
  // console.log(formattedDateTime)

  return formattedDateTime;
}


getArrayData(){
  let fromAirport:any=this.array[0].departure
  let toAirPort:any=this.array[this.array.length-1]
  let via:any=[]
  this.array.forEach((item:any)=>{
    if(item.arrivel!=toAirPort.arrivel){
    via.push(item.arrivel)
  }
  })
  this.array.filter((item:any)=>item.to)
  return fromAirport+" To "+toAirPort.arrivel+" Via "+via.join(',')
}
showMultiSearch:boolean=false
onMultiSearchClick(){
  this.selectedDetail=false

  this.showMultiSearch=true
}
onHideMulti(){
  this.showMultiSearch=false

}




suggestions: any[] = [];
filteredUser: any[] = [];;

searchList(event: AutoCompleteCompleteEvent) {
  let filtered: any[] = [];
    let query = event.query;
console.log(event.originalEvent)
    for (let i = 0; i < (this.suggestions as any[]).length; i++) {
        let user = (this.suggestions as any[])[i];
        if (user.name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
            filtered.push(user);
        }
    }

    this.filteredUser = filtered;
}
getUsersList(){
  let userType:any
      this.userService.getUserList('')
      .subscribe({
        next : (res:any) => {
          if(res) {
           // console.log(res)
          let  data:any;
          data=res["result"]
          this.suggestions=data
          // for (let i = 0; i < data.length; i++) {
            
          //   this.whereTo.push(data[i]?.name);

          // }
   
        }else{

        }},error : (err) => {
    
          console.error("Error in fetching data");
        }
      }
    )
    
  }
  GetChildData()
{
  this.generatePnr=false
}



myControl = new FormControl('');
options: string[] = ['One', 'Two', 'Three'];
filteredOptions!: Observable<any>;
myDealControl = new FormControl('');
filteredDealCodeOptions!: Observable<any>;
carrierCodeList:any=[]


private _filters(value: string): string[] {
  const filterValue = value.toLowerCase();

  return this.carrierCodeList.filter((option:any) => option.airlineDesignatorCode.toLowerCase().includes(filterValue)||option.carrierName.toLowerCase().includes(filterValue));
}
carrierCodelist(){

  this.AirManagementService
  .carrierlist()
  .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res
     this.carrierCodeList=data
     if(this.searchData!="default message"){

     let carrier:any=''
     
     if(this.carrierCodeList.length!=0){
       if(this.searchData?.prefAirline){
       carrier=this.carrierCodeList.filter((option:any) => option.airlineDesignatorCode===this.searchData.prefAirline)[0]
     carrier=carrier?.carrierName+','+carrier?.airlineDesignatorCode
     }
     }
     
     this.myControl= new FormControl(carrier)
     this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map((value:any) => this._filters(value || '')),
    );
    }
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}
changeCarrier(){
  this.prefAirline=this.myControl.value?.split(',')[1]||''
}


// base64ToArrayBuffer(base64: string): ArrayBuffer {
//   const binaryString = window.atob(base64);
//   const len = binaryString.length;
//   const bytes = new Uint8Array(len);
//   for (let i = 0; i < len; i++) {
//     bytes[i] = binaryString.charCodeAt(i);
//   }
//   return bytes.buffer;
// }
htmlContent:any
// readFile(input:any) {

//   const arrayBuffer = this.base64ToArrayBuffer(input.split(',')[1]);
//   mammoth.convertToHtml({ arrayBuffer })
//     .then(result => {
//       this.htmlContent = result.value;
//     })
//     .catch(err => {
//       console.error('Error converting .docx:', err);
//     });
// }


base64ToArrayBuffer(base64: string): ArrayBuffer {
  const binaryString = window.atob(base64);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
}

readFile(base64String: string): void {
  const mimeInfo = base64String.substring(0, base64String.indexOf(','));
  const mimeType = mimeInfo.match(/data:([^;]+);/)?.[1] || '';

  const pureBase64 = base64String.split(',')[1];

  if (mimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
    // Handle DOCX
    const arrayBuffer = this.base64ToArrayBuffer(pureBase64);
    mammoth.convertToHtml({ arrayBuffer })
      .then(result => {
        this.htmlContent = this.sanitizer.bypassSecurityTrustHtml(result.value);

      })
      .catch(err => {
        console.error('Error converting .docx:', err);
      });

  } else if (mimeType === 'application/pdf') {
    // Handle PDF
    const embedHtml = `<embed src="${base64String}" type="application/pdf" width="100%" height="600px"/>`;
    this.htmlContent = this.sanitizer.bypassSecurityTrustHtml(embedHtml);

  } else if (mimeType.startsWith('image/')) {
    // Handle Image
    const imageHtml = `<img src="${base64String}" alt="Uploaded Image" style="max-width: 100%; height: auto;" />`;
    this.htmlContent = this.sanitizer.bypassSecurityTrustHtml(imageHtml);
  
  } else {
    this.htmlContent = `<p style="color: red;">Unsupported MIME type: ${mimeType}</p>`;
  }
}


currentIndex = 0;
currentItem: any;


notificationData:any=[]
updateData() {
  
  this.currentItem = this.notificationData[this.currentIndex];
  this.currentIndex = (this.currentIndex + 1) % this.notificationData.length;
  // console.log(this.currentItem)
  if(this.currentItem?.source)
  {
  this.readFile(this.currentItem.source)}
}




notificationlist(){

  this.NotificationSettingsService
  .QueueAlllist()
  .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res
     this.notificationData=data
  //  console.log(data)
   if(this.notificationData){
    if(this.notificationData?.length!=0){
      this.updateData();
      if(this.notificationData?.length!=1){

      setInterval(() => this.updateData(), 6000);}
    }
   }
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}

dealList:any=[]
dealCodeList(){
  this.FlightService
  .getDealCodeList()
  .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res
 this.dealList=data?.result||[]
 if(this.searchData!="default message"){

 let code:any=''
 if(this.dealList.length!=0){
  if(this.searchData?.dealCode){
  code=this.dealList.filter((option:any) => option.userUid===this.searchData.dealCode)[0]
  console.log(code)
  code=code?.name+','+code?.userUid
}
}

 this.myDealControl= new FormControl(code)
     this.filteredDealCodeOptions = this.myDealControl.valueChanges.pipe(
      startWith(''),
      map((value:any) => this._filtersDeal(value || '')),
    );}
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}

private _filtersDeal(value: string): string[] {
  const filterValue = value.toLowerCase();

  return this.dealList.filter((option:any) => option.userUid.toLowerCase().includes(filterValue)||option.name.toLowerCase().includes(filterValue));
}

changeDealCode(){
  this.dealCode=this.myDealControl.value?.split(',')[1]||''
}



showAir:boolean=false
generalConfig(id:any){

let uuid:any
if(id){
uuid=id
}else{
  uuid="0"
}
  this.AirConfigService
  .getGeneralConfig(uuid)
  .subscribe({
    next : (res:any) => {
      if(res) {
        let data=res
        if(data.length>0){
          console.log(data)
          this.showAir=data[0].airProduct
        }else{

        }

      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}
}

